import { render } from "./Cancelamento.vue?vue&type=template&id=efc7af70&scoped=true"
import script from "./Cancelamento.vue?vue&type=script&lang=js"
export * from "./Cancelamento.vue?vue&type=script&lang=js"

import "./Cancelamento.vue?vue&type=style&index=0&id=efc7af70&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efc7af70"]])

export default __exports__